module.exports = __webpack_public_path__ + "img/china.e878b4f7.webp";